import { render, staticRenderFns } from "./notifier.vue?vue&type=template&id=053f0106&"
import script from "./notifier.vue?vue&type=script&lang=js&"
export * from "./notifier.vue?vue&type=script&lang=js&"
import style0 from "./notifier.vue?vue&type=style&index=0&id=053f0106&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports